import { type Filter, FilterId, FilterType } from '../../types/filters';
import type { CustomSkillTreeNode } from '../skillTaxonomyTree';

export const isCompositionV3CustomSkillTaxonomyReady = ({
  effectiveFilters,
  customSkillTree,
  isCustomSkillLevelMapReady,
  isCustomSkillTaxonomyPending = false,
}: {
  effectiveFilters: Filter[];
  customSkillTree: CustomSkillTreeNode[] | null;
  isCustomSkillLevelMapReady: boolean;
  /** True while skill taxonomy / level map is still loading (reference API or legacy list). */
  isCustomSkillTaxonomyPending?: boolean;
}): boolean => {
  // skill_breakdown_level (getCompositionV3BreakdownOptions) derives from the
  // custom-skill tree depth on EVERY composition request — even with no skill
  // selections. Wait for the taxonomy fetch to settle so the request can't fire
  // with the SkillLvl_1 fallback before the tree resolves (a race that lands
  // deterministically on slow / prod builds).
  if (isCustomSkillTaxonomyPending) {
    return false;
  }

  const hasCustomSkillSelections = effectiveFilters.some(
    (f) =>
      f.id === FilterId.CUSTOM_SKILL &&
      f.type === FilterType.TREE &&
      f.selections.length > 0
  );

  if (!hasCustomSkillSelections) {
    return true;
  }

  if (!isCustomSkillLevelMapReady) {
    return false;
  }

  return Array.isArray(customSkillTree) && customSkillTree.length > 0;
};
